import { Component } from '@angular/core';
import { AlertController, NavParams, ToastController, ViewController } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { TranslateService } from '@ngx-translate/core';
import { TPVServices } from '../../../tpv/services';

/**
 * Component que devuelve un datetime segun lugar (espana - usa)
 *
 */

@Component({
  selector: 'create-room',
  templateUrl: 'create-room.html',
})
export class CompCreateRoomPage {
  room: any;
  update_state: boolean = false;
  is_list: boolean = true;
  old_name: string = "";

  constructor(
    public globals: Globals,
    public viewCtrl: ViewController,
    public translate: TranslateService,
    public navParams: NavParams,
    public tpvServices: TPVServices,
    public toastCtrl: ToastController,
    public alertCtrl: AlertController) {
    this.room = this.navParams.get('room');
    this.old_name = this.room.name;
    this.update_state = this.navParams.get('update');
    if (this.update_state) {
      if (this.room.map != undefined && this.room.map === true) {
        this.is_list = false;
      } else {
        this.is_list = true;
      }
    }
  }

  close(info_return = undefined) {
    this.viewCtrl.dismiss(info_return);
  }

  save() {
    if (this.checkInputs()) {
      if (this.update_state == true) {
        this.updateRoom(this.room);
      } else if (this.update_state == false) {
        this.insertRoom(this.room);
      }
      this.close();
    } else {
      let toast = this.toastCtrl.create({
        message: this.translate.instant('instant-rellena-todos-campos-formulario'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
    }
  }

  checkInputs() {
    if (!this.room.name) {
      return false;
    }
    return true;
  }

  insertRoom(room_info) {
    this.tpvServices.afs.collection('rooms').add({
      'UID_RESTAURANT': this.globals.restaurant_uid,
      'name': room_info.name,
      'map': this.is_list == true ? false : true,
      'order': room_info.order || 0,
    }).then(doc => {
      this.globals.GAtrackView('Configuration', 'Configuration - Rooms - Create', this.globals.restaurant.email, 'Create/Update', 'Create room', 'Configuration', room_info.name);
    });
  }

  updateRoom(room_info) {
    this.tpvServices.afs.collection('rooms').doc(this.room.UID).update({
      'name': room_info.name,
      'map': this.is_list == true ? false : true,
      'order': room_info.order,
    }).then(() => {
      this.globals.GAtrackView('Configuration', 'Configuration - Rooms - Update', this.globals.restaurant.email, 'Create/Update', 'Update room', 'Configuration', room_info.name);
      //Actualizar mesas del room en caso de cambio de nombre
      if (this.old_name != room_info.name) {
        this.updateRoomNameInTables(room_info.name);
      }
    });
  }

  updateRoomNameInTables(room_name) {
    this.tpvServices.firestore.collection('tables').where('UID_RESTAURANT', '==', this.globals.restaurant_uid)
      .where('uid_room', '==', this.room.UID).get()
      .then(snapshot => {
        snapshot.forEach(doc => {
          var table = doc.data();
          table.UID = doc.id;
          //update room name
          this.tpvServices.afs.collection('tables').doc(table.UID).update({ 'room': room_name, }).then(() => { });
        });
      });
  }

  deleteRoom() {
    let alert = this.alertCtrl.create({
      title: this.translate.instant('instant-eliminar-comedor'),
      message: this.translate.instant('instant-seguro-quieres-eliminarlo'),
      buttons: [
        {
          text: this.translate.instant('general-no'),
          role: 'cancel',
          handler: () => { }
        },
        {
          text: this.translate.instant('general-si'),
          handler: () => {
            this.close();
            this.deleteTablesAndRoom();
          }
        }
      ]
    });
    alert.present();
  }

  async deleteTablesAndRoom() {
    const deletingAlert = await this.alertCtrl.create({
      title: this.room.name,
      message: this.translate.instant('instant-eliminando-comedor-mesas'),
    });

    await deletingAlert.present();
    try {
      this.globals.GAtrackView('Configuration', 'Configuration - Rooms - Delete', this.globals.restaurant.email, 'Create/Update', 'Delete room', 'Configuration', this.room.name);

      //Eliminar todas las mesas de la room
      await this.tpvServices.firestore.collection('tables').where('UID_RESTAURANT', '==', this.globals.restaurant_uid)
        .where('uid_room', '==', this.room.UID).get()
        .then(snapshot => {
          snapshot.forEach(async doc => {
            var table = doc.data();
            table.UID = doc.id;
            await this.tpvServices.afs.collection('tables').doc(table.UID).delete();
          });
        });


      //eliminar room
      await this.tpvServices.afs.collection('rooms').doc(this.room.UID).delete();
      let index = this.tpvServices.rooms_panels.findIndex(x => x.UID === this.room.UID);
      if (index >= 0) {
        this.tpvServices.rooms_panels.splice(index, 1);
      }
    } catch (error) {
      await deletingAlert.dismiss(); // Cerrar el alert de "Eliminando..."
    } finally {
      await deletingAlert.dismiss(); // Cerrar el alert de "Eliminando..."
    }
  }

}


// WEBPACK FOOTER //
// ./src/pages/components/popups/create-room/create-room.ts